import React from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "../../components/ui";
import { ProgressSpinner } from "primereact/progressspinner";
import { SupportArticleForm } from "../../components/Forms/SupportArticleForm";
import { useGetSupportArticleByIdQuery } from "../../store/services/support";

export function SupportArticleNew() {
  return (
    <div className="grid">
      <div className="col-12">
        <Breadcrumb items={[{ label: "Artículos", to: "/soporte/articulos" }, { label: "Nuevo artículo" }]} />
        <div className="p-card p-4">
          <div className="flex align-items-center justify-content-between mb-4">
            <h3 className="text-2xl font-semibold text-900 m-0">
              <i className="pi pi-plus mr-2 text-primary"></i>
              Nuevo artículo de soporte
            </h3>
          </div>
          <SupportArticleForm isEdit={false} />
        </div>
      </div>
    </div>
  );
}

export function SupportArticleEdit() {
  const { id } = useParams<{ id: string }>();
  const { data: article, isLoading, error } = useGetSupportArticleByIdQuery(id!, {
    skip: !id,
  });

  if (isLoading) {
    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <ProgressSpinner />
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="grid">
        <div className="col-12">
          <div className="p-card p-4">
            <h5>Error</h5>
            <p>No se pudo cargar el artículo solicitado.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid">
      <div className="col-12">
        <Breadcrumb items={[{ label: "Artículos", to: "/soporte/articulos" }, { label: article.title ?? "Editar" }]} />
        <div className="p-card p-4">
          <div className="flex align-items-center justify-content-between mb-4">
            <h3 className="text-2xl font-semibold text-900 m-0">
              <i className="pi pi-pencil mr-2 text-primary"></i>
              Editar artículo: {article.title}
            </h3>
            <div className="flex align-items-center gap-2 text-600">
              <small>Versión actual: {article.version}</small>
            </div>
          </div>
          <SupportArticleForm
            isEdit={true}
            articleId={article.id}
            articleTenantId={article.tenantId}
            initialCategoryName={article.categoryName}
            versions={article.versions}
            initialValues={{
              title: article.title,
              category_id: article.categoryId,
              body: article.body,
              search_tags: article.searchTags,
              sort_order: article.sortOrder ?? null,
              change_summary: "",
              is_active: article.isActive,
            }}
          />
        </div>
      </div>
    </div>
  );
}
